import Vue from 'vue'
import router from '@/router'
import api from '@/api/index'
import config from '@/config/index'
import utils from '@/utils'
import orgurl from '@/utils/orgurl'
import { getCookie } from '@/store/cookies'
import {GETMENUS_SUCCESS} from "../types";

const state = {
  menus: []
}

const actions = {
  getMenus (store, params) { // 获取菜单
    var dev = false;
    if (window.location.hostname == 'localhost') {
      dev = true;
    }
    var orgprefix = ''
    var businessId = ''
    if (getCookie('org')) {
      businessId = getCookie('org').businessId
    }
    switch (businessId) {
      case '1':
        orgprefix = '/continueEdu'
        break
      case '2':
        orgprefix = ''
        break
      case '3':
        orgprefix = '/entrain'
        break
      case '4':
        orgprefix = ''
        break
      default:
        if (dev) { // 开发状态下没有businssId的情况
          if (window.location.hash.split('/')[1] == 'org') {
            orgprefix = ''
          } else { // 模拟其他机构的情况
            orgprefix = '/continueEdu'
          }
        } else {
          orgprefix = ''
        }
        break
    }
    function iteration (data, level) {
      level++
      for (var j = 0; j < data.length; j++) {
        data[j].opened = false // 菜单是否打开
        data[j].active = false // 是否高亮
        data[j].level = level
        data[j].redirectTo = orgprefix + data[j].href
        if (data[j].children != undefined && data[j].children.length > 0) {
          iteration(data[j].children, level)
        }
      }
    }
    api.post(config.bylBaseCenterPath, '/menu/listByRole', params, function (r) { // 获取正常
      var d = r.data
      iteration(d, 0)
      store.commit(GETMENUS_SUCCESS, d) // 更新state
    })
  }
}
const mutations = {
  [GETMENUS_SUCCESS] (state, action) {
    state.menus = action
  }
}

const getters = {
  getCurrentMenus: state => {
    if (state.menus) {
      return state.menus
    } else {
      return []
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/orgmenus.js